import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Box, Grid, Typography, CircularProgress, Button, Menu, MenuItem } from "@mui/material";
import {
  getMisReport,
  getMisReportDownload,
} from "redux/actions/ReportsAction";
import { fetchCompanyList } from "redux/actions/companyAction";
import { getServiceCity } from "redux/actions/UserServiceCity";
import CommonButton from "components/commonButton/CommonButton";
import CommonTable from "components/commonTable/CommonTable";
import Loader from "components/loader/Loader";
import CommonFilter from "components/commonFilter/CommonFilter";
import CommonDateRangePicker from "components/commonDateRangePicker/CommonDateRangePicker";
import BillingFilter from "pages/operation/billing/billingFlow/billingFilter/BillingFilter";
import { getDateFormat } from "utils/utils";
import { debounce, isArray } from "lodash";
import { misFilterData, misFilterOptions } from "./MisReportData";
import { requestBookingReportApi } from 'services/BookingReportService';
import { useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";

function Report() {
  const dispatch = useDispatch();
  const { state } = useLocation();
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [status, setStatus] = useState([]);
  const [location, setLocation] = useState([]);
  const thirtyDaysAgo = new Date();
  thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
  const [dateFrom, setDateFrom] = useState(
    getDateFormat(thirtyDaysAgo, "reservationDateFormat")
  );
  const [dateTo, setDateTo] = useState(
    getDateFormat(new Date(), "reservationDateFormat")
  );
  const [isRequestingReport, setIsRequestingReport] = useState(false);

  const misLoader = useSelector((state) => state?.getMisList?.loading);
  const misDataList = useSelector((state) => state?.getMisList?.misList?.data);

  // New Filter added
  const [billingFilter, setBillingFilter] = useState({
    companyName: {},
    city: {},
  });

  let filterData = {
    search: "",
  };
  useEffect(() => {
    dispatch(
      fetchCompanyList(filterData, {
        searchType: "globalSearch",
        loader: "backDropLoader",
      })
    );
    dispatch(getServiceCity());
  }, []);

  const companyTableData = useSelector(
    (state) => state?.userCompany?.companyList?.body
  );
  const locationOptions = useSelector(
    (state) => state?.userServiceCity?.userServiceCity?.data
  );

  const companyOption =
    companyTableData?.length > 0 &&
    companyTableData?.map((val) => {
      return { value: val?.id, label: val.name };
    });

  const cityOption =
    locationOptions?.length > 0 &&
    locationOptions?.map((val) => {
      return { value: val?.id, label: val.name };
    });

  const handleFilter = (name, newValue) => {
    setBillingFilter((prevState) => ({
      ...prevState,
      [name]: newValue,
    }));

    if (name === "companyName") {
      const bookingReportPayloads = {
        ...revenueReportPayload,
        companyId: newValue?.value,
        page: 0,
      };
      dispatch(getMisReport(bookingReportPayloads));
    } else if (name === "city") {
      const bookingReportPayloads = {
        ...revenueReportPayload,
        city: newValue?.value,
        page: 0,
      };
      dispatch(getMisReport(bookingReportPayloads));
    }
  };

  //company Auto suggestion
  const onHandleAutoSuggestion = debounce((event, value, fieldName) => {
    if (event?.type === "change") {
      if (fieldName === "companyName" && value) {
        dispatch(
          fetchCompanyList(
            { ...filterData, search: value },
            { searchType: "globalSearch", loader: "backDropLoader" }
          )
        );
      } else {
        dispatch(
          fetchCompanyList(filterData, {
            searchType: "globalSearch",
            loader: "backDropLoader",
          })
        );
      }
    }
  }, 500);

  let revenueReportPayload = {
    page: page,
    pageSize: rowsPerPage,
    status: status,
    location: location,
    dateTo: dateTo,
    dateFrom: dateFrom,
    city: billingFilter?.city?.value,
    report: true,
    companyId: billingFilter?.companyName?.value,
  };

  useEffect(() => {
    dispatch(getMisReport(revenueReportPayload));
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    dispatch(getMisReport({ ...revenueReportPayload, page: newPage }));
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
    dispatch(
      getMisReport({
        ...revenueReportPayload,
        page: 0,
        pageSize: parseInt(event.target.value),
      })
    );
  };

  //Date Filter
  const onSelectDateRange = (newValue) => {
    setPage(0);
    if (newValue === null || newValue === 0) {
      setDateFrom("");
      setDateTo("");
      revenueReportPayload = {
        ...revenueReportPayload,
        dateFrom: "",
        dateTo: "",
        page: 0,
      };
    } else {
      setDateFrom(getDateFormat(newValue[0], "reservationDateFormat"));
      setDateTo(getDateFormat(newValue[1], "reservationDateFormat"));
      revenueReportPayload = {
        ...revenueReportPayload,
        dateFrom: getDateFormat(newValue[0], "reservationDateFormat"),
        dateTo: getDateFormat(newValue[1], "reservationDateFormat"),
        page: 0,
      };
    }
    dispatch(getMisReport(revenueReportPayload));
  };

  const onFilterChange = (val) => {
    const defaultStatus = ["1", "2"];
    const defaultLocation = ["rental", "airport", "outStation"];
    const filterStatus = val.filter((status) => {
      return defaultStatus.includes(status);
    });

    const filterLocations = val.filter((DutyType) => {
      return defaultLocation.includes(DutyType);
    });

    setLocation(filterLocations);
    setStatus(filterStatus);
    setPage(0);

    const bookingReportPayloads = {
      ...revenueReportPayload,
      status: filterStatus?.toString(),
      location: filterLocations?.toString(),
      page: 0,
    };
    dispatch(getMisReport(bookingReportPayloads));
  };

  // ---Reset Filter---
  const onRestFilter = () => {
    dispatch(
      getMisReport({
        ...revenueReportPayload,
        status: "",
        location: "",
        page: 0,
      })
    );
    dispatch(
      getMisReport({
        ...revenueReportPayload,
        status: "",
        location: "",
        page: 0,
      })
    );
    setStatus([]);
    setLocation([]);
    setPage(0);
  };

  const onClick = () => {
    const reservationPayload = {
      ...revenueReportPayload,
      export: true,
      report: false,
    };
    dispatch(getMisReportDownload(reservationPayload));
  };

  const onRequestReport = async (format) => {
    setIsRequestingReport(true);
    setIsRequestingReport(false);
  try {
    const payload = {
      startDate: dateFrom,
      endDate: dateTo,
      reportType: "B2B_TRIP_TRANSACTION_REPORT",
      reportFormate: format,
      filters: {
        location: revenueReportPayload?.city,
        type: revenueReportPayload?.location && isArray(revenueReportPayload?.location) ? revenueReportPayload?.location.join(',') : '',
        companyId: revenueReportPayload?.companyId,
        parentCompany: revenueReportPayload?.parentCompany,
        status: revenueReportPayload?.status && isArray(revenueReportPayload?.status) ? revenueReportPayload?.status.join(',') : ''
      }
    };
    const response = await requestBookingReportApi(payload);
    if (response.success) {
      toast.success("Report request submitted successfully");
      navigate("/report-generate");
    } else {
      toast.error(response?.message || "Failed to request report");
    }
    } catch (error) {
      toast.error("Error requesting report");
    }
      finally {
      setIsRequestingReport(false);
    }
  };
  
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleSelectFormat = (format) => {
    onRequestReport(format);
    handleClose();
  };

  return (
    <Box>
      <Box className="justifyBetween pb10">
        <Typography variant="body1" className="colorPrimary">
          Transaction Data
        </Typography>
      </Box>

      <Grid 
        container 
        spacing={2}
        sx={{ width: '100%' }}
      >
        <Grid container 
          gap={2}
          sx={{ width: '100%' }}
          flexWrap={{ xs: "wrap", sm: "wrap", md: "nowrap", lg: "nowrap" }}
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          >
          <Grid
            item
            container
            sx={{ width: '100%', marginLeft: '10px' }}
            gap={2}
          >
            {misFilterOptions(companyOption, cityOption) &&
              misFilterOptions(companyOption, cityOption)?.map(
                (formData, index) => (
                  <Grid
                    item
                    lg={5}
                    md={12}
                    xs={12}
                    key={index}
                    className="misAutoComplete"
                  >
                    <BillingFilter
                      billingFilterValue={billingFilter}
                      setBillingFilter={setBillingFilter}
                      handleFilter={handleFilter}
                      formData={formData}
                      onHandleAutoSuggestion={onHandleAutoSuggestion}
                    />
                  </Grid>
                )
              )}
          </Grid>
          <Grid
            container
            item
          >
            <Grid item lg={12} xs={12} className="justifyEnd" style={{ marginTop: "24px", marginLeft: '10px'}}>
              <CommonDateRangePicker
                onSelectDateRange={onSelectDateRange}
                dateFrom={dateFrom}
                dateTo={dateTo}
              />
              <CommonFilter
                defaultStatus={status}
                filterdata={misFilterData}
                onFilterChange={onFilterChange}
                onRestFilter={onRestFilter}
                defaultLocation={location}
              />
            </Grid>
            <div style={{ display: "flex", gap: "20px", marginTop: '10px', justifyContent: 'flex-end', width: '100%' }}>
              <Button
                onClick={handleClick}
                disabled={isRequestingReport}
                sx={{
                  backgroundColor: '#1976d2',
                  borderRadius: '8px',
                  color: '#fff',
                  textTransform: 'none',
                  paddingX: 2,
                  paddingY: 1,
                  '&:hover': {
                    backgroundColor: '#1565c0',
                  },
                  '&.Mui-disabled': {
                    backgroundColor: '#9e9e9e',
                    color: '#fff',
                  },
                }}
              >
                {isRequestingReport ? (
                  <CircularProgress
                    size={20}
                    sx={{ color: "#fff" }}
                  />
                ) : (
                  "Request Report"
                )}
              </Button>
              <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                PaperProps={{
                  sx: { width: anchorEl ? anchorEl.offsetWidth : "auto" }, // match button width
                }}
              >
                <MenuItem onClick={() => handleSelectFormat("csv")} sx={{ width: "100%",  fontSize: "14px" }}>
                  Excel/CSV
                </MenuItem>
                <MenuItem onClick={() => handleSelectFormat("pdf")} sx={{ width: "100%",  fontSize: "14px" }}>
                  PDF
                </MenuItem>
              </Menu>
              <CommonButton
                name="Send Report to mail"
                btnClass="btnSm btnYellow"
                onClick={onClick}
              />
            </div>
          </Grid>
        </Grid>

        {misLoader ? (
          <Loader height={"60vh"} />
        ) : (
          <Box sx={{ width: '100%', overflowX: 'auto', maxHeight: '80vh', overflowY: 'auto', marginLeft: '10px' }}>
            <CommonTable
              data={misDataList}
              page={page}
              rowsPerPage={rowsPerPage}
              handleChangePage={handleChangePage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              minWidth={true}
              isClickable={false}
            />
          </Box>
        )}
      </Grid>
    </Box>
  );
}

export default Report;
